import {  QUESTION_LIST, QUESTION_DETAILS } from './../constant/ActionTypes';

export const questionReducer = (state, action) => {
    switch (action.type) {
        case QUESTION_LIST:
            return { 
                ...state, 
                questionList: action.payload 
            };
        case QUESTION_DETAILS:
            return { 
                ...state, 
                questionDetails: action.payload 
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/questionReducer.js